import HttpRequest from '@/libs/axios'
import config from '@/config'
const baseUrl = config.baseUrl.dev

export default new HttpRequest(baseUrl)
